/**
 * Abfrage der Office.js-Anforderungssätze zur Laufzeit.
 *
 * Jede Office-Anwendung hat ihre eigenen Anforderungssätze ("WordApi",
 * "PowerPointApi", …). Die Abfrage selbst ist überall dieselbe, deshalb steht
 * sie hier gemeinsam für alle Kurse. Welche Sätze ein Kurs braucht, steht in
 * der jeweiligen `capabilities.ts`.
 */

/**
 * Steht der Anforderungssatz in dieser Office-Version zur Verfügung?
 *
 * Außerhalb von Office – etwa beim Öffnen im normalen Browser – gibt es kein
 * `Office`-Objekt. Dann lautet die Antwort `false`, ohne dass ein Fehler
 * hochblubbert.
 */
export function isSetSupported(name: string, version: string): boolean {
  try {
    return (
      typeof Office !== "undefined" &&
      Office.context?.requirements?.isSetSupported(name, version) === true
    );
  } catch {
    return false;
  }
}
